import React from "react";
import { useTranslation } from "react-i18next";

const DepositAgreementHeader = () => {
  const t = useTranslation("depositAgreement\\depositAgreement").t;

  return (
    <div className="d-none d-sm-block px-3 mb-2 text-muted font-weight-bold">
      <div className="row no-gutters align-items-center">
        <div className="col-12 col-sm-11 col-md-11 col-lg-10 col-xl-10">
          <div className="row no-gutters align-items-center">
            <div className="col-12 col-sm-3 col-md-3 col-lg-3 text-truncate">
              {t("header.contractNumber")}
            </div>
            <div className="col-12 col-sm-4 col-md-4 col-lg-3 text-truncate">
              {t("header.depositAgreementNumber")}
            </div>
            <div className="col-12 col-sm-3 col-md-3 col-lg-3 text-truncate">
              <span className="d-xl-none">{t("header.dueDate")}</span>
              <span className="d-none d-xl-inline">
                {t("header.issueDate")}/{t("header.dueDate")}
              </span>
            </div>
            <div className="col-12 col-sm-2 col-md-2 col-lg-3 text-truncate">
              <span className="d-lg-none">{t("header.amount")}</span>
              <span className="d-none d-lg-inline">
                {t("header.amount")}/{t("header.used")}
              </span>
            </div>
          </div>
        </div>

        <div className="d-none d-lg-block col-lg-1 col-xl-1 text-truncate">
          {t("header.status")}
        </div>

        <div className="col-12 col-sm-1 col-md-1 col-lg-1 col-xl-1" />
      </div>
    </div>
  );
};

export default DepositAgreementHeader;
